module.exports = __webpack_public_path__ + "static/img/SUB_02_02.c9001e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/SUB_02_02.png
// module id = dFHu
// module chunks = 1